<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.subjects
</script>

<div class="{klass}">
	<FormWithLabel
		label="科目"
		input={service.handleSubjects}
		values={$model.subjects}
		inputType="checkboxes"
		options={$models}
	/>
</div>